import { string as yupString, object as yupObject } from 'yup';

import { Organization } from 'types';

export interface StationFormState {
  en_name: string;
  ar_name: string;
  station_code: string;
  organisationId: string;
  enabled: boolean;
  organisation?: Organization;
}

const STATION_CODE_PATTERN = /^[A-Za-z]+[0-9]+$/;

const StationFormSchema = intl => {
  const validationRequiredMessage = intl.formatMessage({
    id: 'requiredValidation',
  });

  const stationCodePatternMessage = intl.formatMessage({
    id: 'stationCodeAlphanumeric',
  });

  return yupObject().shape({
    en_name: yupString().required(validationRequiredMessage),
    ar_name: yupString().required(validationRequiredMessage),
    station_code: yupString()
      .required(validationRequiredMessage)
      .matches(STATION_CODE_PATTERN, stationCodePatternMessage),
    organisationId: yupString().required(validationRequiredMessage),
  });
};

export { StationFormSchema, STATION_CODE_PATTERN };
